<template>
  <div class="snBtnView">
    <el-popover ref="getOIDPanel" placement="top" width="400" trigger="click" v-model="popVis">
      <div style="text-align: right; margin: 0">
        <el-input style="width: 300px" v-model="deviceSN" placeholder="输入设备SN号" />

        <el-button size="mini" type="text" @click="popVis=false">取消</el-button>
        <el-button type="primary" size="mini" @click="popConfirm">确定</el-button>
      </div>
    </el-popover>

    <el-button
      size="small"
      type="info"
      class="snBtn"
      v-popover:getOIDPanel
      :disabled="mode!='edit'&&mode!='quantu'"
    >{{btnName}}</el-button>
    <!--
    <div class="snBtn2" v-if="isConnect==true">
      <p v-show="deviceSN!=''">SN:{{deviceSN}}</p>
    </div>
    -->
  </div>
</template>

<script>
import VueCookie from "vue-cookie";
export default {
  name: "getOID",
  data() {
    return {
      popVis: false,
      deviceSN: "",
      OID: "",
      viewOID: "",
      path: "",
      socket: "",
      isConnect: false,
      timer: "",
      btnName: "绑定设备",
    };
  },
  created() {
    let deviceSNTemp = localStorage.getItem("deviceGetOidSn");
    if (deviceSNTemp != null) {
      console.log(deviceSNTemp);
      this.deviceSN = deviceSNTemp;
      this.initWebSocket();
    }
  },
  watch: {
    //OID(newData) {
    //  this.$emit("updateOID", this.OID);
    //},
    isConnect(newData) {
      if (newData === true) {
        this.btnName = "更换设备";
      } else {
        this.btnName = "绑定设备";
      }
    },
  },
  props: {
    mode: {
      type: String,
      default: "",
    },
    code: {
      type: String,
      default: "",
    },
  },
  methods: {
    popConfirm() {
      if (this.isConnect) {
        clearInterval(this.timer);
        this.socket.onclose = this.close;
        this.socket.close();
      }
      this.popVis = false;
      this.initWebSocket();
    },
    initWebSocket() {
      if (typeof WebSocket === "undefined") {
        alert("您的浏览器不支持socket");
      } else {
        let isHttps = "https:" == document.location.protocol ? true : false;
        let url = window.location.href;
        let evnTemp = null;
        if (url.indexOf("restartcloud") != -1) {
          evnTemp = "test";
        } else if (url.indexOf("aiedevice") != -1) {
          evnTemp = "line";
        }
        if (isHttps) {
          console.log("https");
          if (evnTemp === "test") {
            this.path = "wss://ai.restartcloud.com/stp/oid/ws";
          } else if (evnTemp === "line") {
            this.path = "wss://www.aiedevice.com/stp/oid/ws";
          }
        } else {
          console.log("http");
          if (evnTemp === "line") {
            this.path = "ws://www.aiedevice.com/stp/oid/ws";
          } else if (evnTemp === "test") {
            this.path = "ws://ai.restartcloud.com/stp/oid/ws";
          }
        }

        this.socket = new WebSocket(this.path);
        this.socket.onopen = this.open;
        this.socket.onerror = this.error;
        this.socket.onmessage = this.getMessage;
      }
    },
    open() {
      console.log("socket连接成功");
      this.isConnect = true;
      this.send();
      this.timer = setInterval(this.getTimer, 15000);
      localStorage.setItem("deviceGetOidSn", this.deviceSN);
      this.$emit("updateOID", ["connect", this.deviceSN]);
    },
    error() {
      console.log("连接错误");
    },
    getMessage(msg) {
      let rep = JSON.parse(msg.data);
      console.log(
        "[" + rep.time + "] 点读码: <font color='red'>" + rep.oid + "</font>"
      );
      this.viewOID = rep.oid;
      if (rep.oid.indexOf(":") != -1) {
        let arr = rep.oid.split(":", 2);
        if (this.code === "cover") {
          this.OID = arr[0];
        } else if (this.code === "content") {
          this.OID = arr[1];
        } else if (this.code === "all") {
          this.OID = rep.oid;
        } else if (this.code === "allinfo") {
          this.OID = JSON.stringify(rep);
        }
      } else {
        if (this.code === "allinfo") {
          this.OID = JSON.stringify(rep);
        } else {
          this.OID = rep.oid;
        }
      }
      this.$emit("updateOID", this.OID);
    },
    send() {
      let token = VueCookie.get("WEBUI_WEBAPI_TOKEN");
      let params =
        '{"action":"info","data":{"clientId":"' +
        this.deviceSN +
        '","token":"' +
        token +
        '","message":"I am online"}}';
      this.socket.send(params);
    },
    close() {
      console.log("socket已经关闭");
      this.isConnect = false;
      this.$emit("updateOID", ["disconnect", this.deviceSN]);
    },
    getTimer() {
      this.socket.send("heartbeat");
      console.log("heartbeat");
    },
  },
  destroyed() {
    clearInterval(this.timer);
    if (this.isConnect === true) {
      this.isConnect = false;
      this.socket.onclose = this.close;
    }
  },
};
</script>

<style lang="less">
// @import "./index";
// @import "./interact/index";

.snBtnView {
  //height: 50px;
  //line-height: 50px;
  //margin: 5px 30px 5px 10px;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
</style>


// WEBPACK FOOTER //
// getOID.vue?29434f14